import BaseRepository from "@/services/resources/repository";
import queryByKeys from "@/services/resources/mixins/query-by-keys";
import Kernel from "@oilstone/kernel";

class Repository extends BaseRepository {
    static make(model, schema) {
        return new Repository(model, schema).$mix(queryByKeys);
    }

    collection() {
        const queryParams = Kernel.resolve('router').currentRoute.value.query;
        const section = queryParams.section;
        const sectionHomepage = queryParams.sectionHomepage;
        const ignoreParent = queryParams.ignoreParent;
        const query = this.baseQuery();

        if (typeof section !== 'undefined') {
            query.where('section', section);
        }

        if (!ignoreParent) {
            if (sectionHomepage === 'true') {
                query.where('parentId', null);
            } else {
                query.where('parentId', '!=', null);
            }
        }

        return this.transformer.many(
            this.try(
                query.sort('sort').get()
            )
        );
    }

    homepage() {
        return this.transformer.one(
            this.try(
                this.baseQuery().where('section', 'home').where('parentId', null).first()
            )
        );
    }

    sectionHomepages() {
        return this.transformer.many(
            this.try(
                this.baseQuery().where('parentId', null).get()
            )
        );
    }

    sectionHomepage(section) {
        return this.transformer.one(
            this.try(
                this.baseQuery().where('section', section).where('parentId', null).first()
            )
        );
    }

    sectionPages(section) {
        return this.transformer.many(
            this.try(
                this.baseQuery().where('section', section).where('parentId', '!=', null).sort('sort').get()
            )
        );
    }

    footerNavigation() {
        return this.transformer.many(
            this.try(
                this.baseQuery()
                    .where('section', 'footer')
                    .get()
            )
        );
    }

    updateSort(items, element) {
        const change = Math.abs(element.oldIndex - element.newIndex);

        for (let i = Math.min(element.newIndex, element.oldIndex); i < change + 1; i++) {
            const item = items[i];

            this.save({
                id: item.id,
                sort: i + 1,
            });
        }

        return true;
    }

    search(keywords) {
        return this.transformer.many(
            this.try(
                this.baseSearchQuery(
                    ['page-modules.modules.modules'],
                    ['title', 'summary', 'page-modules.modules.modules.attributes']
                    , keywords
                ).get()
            )
        ).then(collection => {
            return collection.map(record => {
                return {
                    type: 'pages',
                    id: record.id,
                    text: record.title,
                    resource: record
                }
            })
        })
    }
}

export default Repository;
